<template>
  <router-view :key="$route.fullPath" />
</template>

<script>
import storeMixin, {
  unRegisterMixin,
} from '@quisit/mipe-utils/mixins/storeGenerator';
const STORE_MODULE_NAME = 'SpecialistAvailabilityCalendarModule';

export default {
  name: 'WrapperSpecialistAvailabilityCalendarModule',
  mixins: [unRegisterMixin, storeMixin],
  data: () => ({
    moduleName: STORE_MODULE_NAME,
  }),
};
</script>
